import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  align-self: stretch;
  min-width: 740px;
  padding-top: ${props => props.theme.spacing.sp16};
`

export const UserImageContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: ${props => props.theme.spacing.sp24};
  align-self: stretch;

  & > img {
    width: 144px;
    height: 144px;
    border-radius: ${props => props.theme.primitives.radius.radiusFull};
    object-fit: cover;
  }
`

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  align-self: stretch;
`

export const InputsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const GroupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const WarningContainer = styled.div`
  margin-top: ${props => props.theme.spacing.sp16};
`
